jQuery(document).ready(function () {
    // Check if newsletter popup exists
    if (jQuery('.newsletter-popup').length) {
        // Don't show popup if newsletter component exists on page
        if (jQuery('.newsletter').length) {
            return;
        }
        
        // Check localStorage to see if user has already seen/closed the popup
        const newsletterClosed = localStorage.getItem('newsletterClosed');
        const newsletterSubscribed = localStorage.getItem('newsletterSubscribed');
        
        // Only show popup if user hasn't closed it or subscribed before
        if (!newsletterClosed && !newsletterSubscribed) {
            // Show newsletter popup after 4 seconds
            setTimeout(function() {
                jQuery('.newsletter-popup__box').addClass('active');
            }, 3000);
        }

        // Close newsletter popup on close button click
        jQuery('.js-newsletter-popup-close').on('click', function() {
            jQuery('.newsletter-popup__box').removeClass('active');
            
            // Remember that user closed the popup (permanently)
            localStorage.setItem('newsletterClosed', 'true');
            
            // Optional: Add timestamp if you want to show again after X days
            // localStorage.setItem('newsletterClosedTime', Date.now());
        });

        // Watch for confirmation message to appear after successful submission
        const observeConfirmation = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Check if confirmation message is now visible in the popup
                const confirmationInPopup = jQuery('.newsletter-popup .webform-confirmation');
                
                if (confirmationInPopup.length && confirmationInPopup.is(':visible')) {
                    // Set localStorage to prevent popup from showing again
                    localStorage.setItem('newsletterSubscribed', 'true');
                    
                    // Auto-close popup after 5 seconds
                    setTimeout(function() {
                        jQuery('.newsletter-popup__box').removeClass('active');
                    }, 5000);
                    
                    // Stop observing once we've detected the confirmation
                    observeConfirmation.disconnect();
                }
            });
        });

        // Start observing the popup for DOM changes
        const popupElement = document.querySelector('.newsletter-popup__main');
        if (popupElement) {
            observeConfirmation.observe(popupElement, {
                childList: true,
                subtree: true
            });
        }
    }
});

// Drupal behavior for newsletter component webform submission
(function ($, Drupal) {
    'use strict';

    Drupal.behaviors.newsletterWebform = {
        attach: function (context, settings) {
            // Listen for AJAX complete on newsletter forms
            $(document).ajaxComplete(function(event, xhr, settings) {
                // Check if confirmation message appeared in newsletter component
                if ($('.newsletter .webform-confirmation').length) {
                    localStorage.setItem('newsletterClosed', 'true');
                }
            });
        }
    };

})(jQuery, Drupal);